import "../global.css.web.css";

// Only import what's absolutely necessary for rendering the download page
import { useEffect } from "react";

export {
    // Catch any errors thrown by the Layout component.
    ErrorBoundary,
} from "expo-router";
import { Image } from "react-native";
// Constants for app store URLs
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.crewsaders.app";
const APP_STORE_URL = "https://apps.apple.com/us/app/crewsaders-crew/id6529552811";

// Export a simple component that doesn't use any TRPC or API calls
export default function WebLayout() {
    useEffect(() => {
        // Add application title
        document.title = "Crewsaders - Download the App";
    }, []);

    // Simple detection for mobile browsers to offer direct store links
    const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    const isAndroid = typeof navigator !== 'undefined' && /Android/.test(navigator.userAgent);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#000000',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            height: '100vh',
            width: '100%'
        }}>
            <div style={{
                marginTop: '40px',
                marginBottom: '40px'
            }}>
                <Image
                    source={require("@/assets/images/new-logo.png")}
                    style={{
                        width: 100,
                        height: 190,
                        objectFit: 'contain'
                    }}

                />
            </div>

            <div style={{
                width: '100%',
                textAlign: 'center'
            }}>
                <h2 style={{
                    fontSize: '22px',
                    fontWeight: '600',
                    marginBottom: '16px',
                    color: '#FFFFFF'
                }}>
                    The Crew app is available exclusively on mobile devices
                </h2>

                <p style={{
                    fontSize: '16px',
                    marginBottom: '30px',
                    color: '#CCCCCC',
                    lineHeight: '24px'
                }}>
                    Download our app to access your schedules, notifications, and much more on the go.
                </p>

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    marginBottom: '20px',
                    gap: '16px'
                }}>
                    {/* iOS App Store Button */}
                    <a
                        href={APP_STORE_URL}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            minWidth: '240px',
                            backgroundColor: '#222222',
                            border: isIOS ? '1px solid #FFED00' : '1px solid #222222',
                            textDecoration: 'none',
                            justifyContent: 'center',
                            gap: '12px',
                            boxShadow: isIOS ? '0 0 8px rgba(255, 237, 0, 0.3)' : 'none',
                            transform: isIOS ? 'scale(1.05)' : 'scale(1)'
                        }}
                    >
                        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.0444 12.7828C17.0352 10.9811 18.5876 9.9255 18.65 9.8864C17.6981 8.482 16.2236 8.2861 15.7043 8.2685C14.4565 8.1375 13.25 9.0188 12.6174 9.0188C11.9672 9.0188 10.9976 8.2803 9.94162 8.3039C8.56531 8.327 7.28169 9.1091 6.57634 10.3569C5.12415 12.8865 6.20068 16.5879 7.59603 18.359C8.29944 19.2306 9.12431 20.2155 10.2126 20.1761C11.2771 20.1328 11.6892 19.4923 12.9722 19.4923C14.2433 19.4923 14.6318 20.1761 15.7475 20.1524C16.9023 20.1328 17.6194 19.2738 18.2997 18.3904C19.1068 17.3644 19.4342 16.3617 19.4518 16.306C19.4224 16.2962 17.0557 15.343 17.0444 12.7828Z" fill="white" />
                            <path d="M15.2724 6.98626C15.852 6.27501 16.2405 5.31689 16.1226 4.34375C15.3406 4.37645 14.3536 4.90376 13.7505 5.59595C13.2174 6.201 12.7486 7.20564 12.8861 8.14626C13.7662 8.21674 14.6692 7.68356 15.2724 6.98626Z" fill="white" />
                        </svg>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }}>
                            <span style={{
                                fontSize: '12px',
                                color: '#CCCCCC',
                                marginBottom: '2px'
                            }}>
                                Download on the
                            </span>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#FFFFFF'
                            }}>
                                App Store
                            </span>
                        </div>
                    </a>

                    {/* Google Play Store Button */}
                    <a
                        href={PLAY_STORE_URL}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            minWidth: '240px',
                            backgroundColor: '#222222',
                            border: isAndroid ? '1px solid #FFED00' : '1px solid #222222',
                            textDecoration: 'none',
                            justifyContent: 'center',
                            gap: '12px',
                            boxShadow: isAndroid ? '0 0 8px rgba(255, 237, 0, 0.3)' : 'none',
                            transform: isAndroid ? 'scale(1.05)' : 'scale(1)'
                        }}
                    >
                        <svg width="40" height="40" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.334 0.586C0.126 0.797 0 1.124 0 1.536V20.46C0 20.872 0.126 21.199 0.334 21.41L0.398 21.47L11.155 10.998V10.998L0.398 0.526L0.334 0.586Z" fill="#5AC8FA" />
                            <path d="M14.737 14.51L11.155 10.998V10.998L14.737 7.486L14.817 7.53L19.063 9.877C20.312 10.55 20.312 11.446 19.063 12.119L14.817 14.466L14.737 14.51Z" fill="#34C759" />
                            <path d="M14.817 14.466L11.155 10.998L0.334 21.41C0.77 21.867 1.483 21.931 2.282 21.494L14.817 14.466Z" fill="#FF2D55" />
                            <path d="M14.817 7.53L2.282 0.502C1.483 0.065 0.77 0.129 0.334 0.586L11.155 10.998L14.817 7.53Z" fill="#FFCC00" />
                        </svg>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }}>
                            <span style={{
                                fontSize: '12px',
                                color: '#CCCCCC',
                                marginBottom: '2px'
                            }}>
                                Get it on
                            </span>
                            <span style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#FFFFFF'
                            }}>
                                Google Play
                            </span>
                        </div>
                    </a>
                </div>
                <p style={{
                    fontSize: '14px',
                    marginTop: '20px',
                    textAlign: 'center',
                    color: '#CCCCCC',

                }}>Looking to join us? Download the app and apply to become a crew member</p>
                {isIOS && (
                    <p style={{
                        marginTop: '20px',
                        textAlign: 'center',
                        color: '#CCCCCC',
                        fontSize: '14px'
                    }}>
                        We've detected you're using an iOS device.{" "}
                        <a
                            href={APP_STORE_URL}
                            style={{
                                color: '#FFED00',
                                textDecoration: 'underline'
                            }}
                        >
                            Click here to open the App Store directly.
                        </a>
                    </p>
                )}

                {isAndroid && (
                    <p style={{
                        marginTop: '20px',
                        textAlign: 'center',
                        color: '#CCCCCC',
                        fontSize: '14px'
                    }}>
                        We've detected you're using an Android device.{" "}
                        <a
                            href={PLAY_STORE_URL}
                            style={{
                                color: '#FFED00',
                                textDecoration: 'underline'
                            }}
                        >
                            Click here to open the Play Store directly.
                        </a>
                    </p>
                )}
            </div>
        </div>
    );
}